import { Button, Stack } from "@mui/material";
import moment from "moment";
import { useState } from "react";
// import { useState } from 'react';
import LocalDatePicker from "src/components/shared/DateRangePicker";

export default function DatePickers({
  state,
  setState,
  secondState,
  setSecondState,
  ...props
}) {
  const [dateToggle, setDateToggle] = useState(true);

  // const [start, setStart] = useState(state);
  // const [end, setEnd] = useState(secondState);
  // const updateDate = () => {
  //   setState(start);
  //   setSecondState(end);
  // };
  return (
    <Stack alignItems={"center"} spacing={2}>
      { 
      dateToggle &&
    
        (<Stack
        direction={"row"}
        alignItems={"center"}
        spacing={2}
        sx={{ margin: "-4px -5px 1px 5px" }}
        display={dateToggle ? "flex" : "none"}
      >
        <LocalDatePicker
          state={secondState}
          setState={setSecondState}
          updateFunction={props?.updateFunction}
        />
        <p style={{ paddingLeft: "5px", width: "30px", height: "30px" }}>
          &nbsp; To: &nbsp;
        </p>
        <LocalDatePicker
          state={state}
          setState={setState}
          updateFunction={props?.updateFunction}
        />
      </Stack>
    )
      }
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          if (!dateToggle) {
            setState(moment());
            setSecondState(moment().add(-7, "day"));
          } else {
            setState("");
            setSecondState("");
          }
          setDateToggle(!dateToggle);
        }}
      >
        {dateToggle ? "Disable Dates" : "Enable Dates"}
      </Button>
    </Stack>
  );
}
